import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const KCPResult = () => {
  return <CommonResult />;
};

export default KCPResult;
